import { render } from "./4TravellerAges.vue?vue&type=template&id=26ea2f37"
import script from "./4TravellerAges.vue?vue&type=script&lang=js"
export * from "./4TravellerAges.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__